import { initSubRoutes } from '../../../../../utils/router';
import { CEAF } from '../../../../../constants/accessibilite.constants';

const RoutesVisualiserCeaf = initSubRoutes({
    route: '/visualiser/:uuidCeaf',
    subroutes: {},
    nom: `Visualiser une carte européenne d'arme à feu (${CEAF})`,
});

export default RoutesVisualiserCeaf;
